import React, { Component }
from 'react';
class ContentLoader extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return(
                <div class="contentLoader-customer">
                    <div class="skeleton">
                        <div class="skeleton-wrapper">
                            <div class="skeleton-wrapper-inner-customer">
                                <div class="skeleton-wrapper-body">
                                    <div class="skeleton-avatar-customer"></div>
                                    <div class="skeleton-author"></div>
                                    <div class="skeleton-label-customer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="skeleton">
                        <div class="skeleton-wrapper">
                            <div class="skeleton-wrapper-inner-customer-sec">
                                <div class="skeleton-wrapper-body customer-loader">
                                <div class="">
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="skeleton customer-skeleton-left">
                        <div class="skeleton-wrapper customer-body-load">
                            <div class="skeleton-wrapper-inner-customer-third">
                                <div class="skeleton-wrapper-body customer-loader-1">
                                <div class="">
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="skeleton customer-skeleton-right">
                        <div class="skeleton-wrapper customer-body-load">
                            <div class="skeleton-wrapper-inner-customer-third">
                                <div class="skeleton-wrapper-body customer-loader-1">
                                <div class="">
                                    
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)
    }
}export default ContentLoader;


// WEBPACK FOOTER //
// ./src/components/customer/contentLoader.js